<template>
    <BasePageDetails v-bind:prop_show_review_buttons="true">
    </BasePageDetails>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

import BasePageDetails from '@/views/base_pages/BasePageDetails';

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ModuleNhmisdqaodkPageDetails',

    components:{
        BasePageDetails
    },

    data: function()
    {
        return {
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
